import PropTypes from "prop-types";

import {
  topicAmountCss,
  topicBlockCss,
  topicLabelCss,
  topicRowCss,
  tokenCss,
} from "./TopicMetaRow.style";

const propTypes = {
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      total: PropTypes.number.isRequired,
      icon: PropTypes.string,
    }),
  ).isRequired,
  isHomeVersion: PropTypes.bool,
  hasBorderBetween: PropTypes.bool,
  small: PropTypes.bool,
};

const TopicMetaRow = ({
  topics,
  isHomeVersion = false,
  hasBorderBetween = false,
  small = false,
}) => {
  return (
    <div css={topicRowCss(small)}>
      {topics.map((topic) => (
        <div key={topic} css={topicBlockCss(hasBorderBetween, small)}>
          {topic?.icon && <img src={topic?.icon} css={tokenCss} alt="" />}
          <span css={topicAmountCss(isHomeVersion, small)}>{topic.total}</span>
          <span css={topicLabelCss(isHomeVersion, small)}>{topic.label}</span>
        </div>
      ))}
    </div>
  );
};

TopicMetaRow.propTypes = propTypes;
export default TopicMetaRow;
